// extracted by mini-css-extract-plugin
export default {"profile__burger":"Burger_profile__burger__JunMz"};